/**
 * Returns css value in `Xpx` in number `X`
 * @param v {string} value with 'px'
 */
export const pxToNumber = (v: string): number => parseFloat(v.split("px")[0]);

/** Returns actual (outer) height with margin */
export const outerHeight = (el: HTMLElement): number => {
  const computedStyle = getComputedStyle(el);
  const height =
    el.clientHeight +
    pxToNumber(computedStyle.marginBottom) +
    pxToNumber(computedStyle.marginTop);
  return height;
};
